import { z } from "zod";

import { DatabaseSystemRecord } from "@/core/api";

export const Attachment = z
  .object({
    id: z.number(),
    signature: z.string(),
    name: z.string(),
    contentType: z.string(),
    publicUrl: z.string().nullable(),
    parsed: z.boolean().optional(),
    parentId: z.number().nullish(),
    createdDate: z.string().optional(),
    defaultFile: z.boolean().nullish(),
  })
  .merge(DatabaseSystemRecord)
  .passthrough();

export type Attachment = z.infer<typeof Attachment>;
